export default __webpack_public_path__ + "navigation-examples-route-init-1200-f105535748a172eead97feefc2d72baf.png";